import getHelpers from './getHelpers'

const mapMultiRowFields = (namespace, fields) =>
  getHelpers(namespace).mapMultiRowFields(fields)

export default mapMultiRowFields
